// International mile = exactly 1609.344 metres. Calculate totals before display rounding.
export const KUTC_REFERENCE_LOOPS = 24;
const HUNDRED_MILES_MILLIMETERS = 160934400;
const EVEREST_HEIGHT_CENTIMETERS = 884886;
export const KUTC_100_MILES_METERS = HUNDRED_MILES_MILLIMETERS / 1000;
export const KUTC_EVEREST_METERS = EVEREST_HEIGHT_CENTIMETERS / 100;
export const kutcDistanceMeters = (loops: number): number => loops * HUNDRED_MILES_MILLIMETERS / (KUTC_REFERENCE_LOOPS * 1000);
export const kutcDistanceKm = (loops: number): number => loops * HUNDRED_MILES_MILLIMETERS / (KUTC_REFERENCE_LOOPS * 1000000);
export const kutcAscentMeters = (loops: number): number => loops * EVEREST_HEIGHT_CENTIMETERS / (KUTC_REFERENCE_LOOPS * 100);
export const KUTC_LOOP_METERS = kutcDistanceMeters(1);
